function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 119.929,
  cy: 149.929,
  r: 99.9295,
  fill: "#40444A"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 76,
  r: 6,
  stroke: "#848D96",
  strokeWidth: 4
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 227,
  r: 6,
  stroke: "#848D96",
  strokeWidth: 4
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 88,
  r: 4,
  fill: "#292F35"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 55,
  cy: 88,
  r: 4,
  stroke: "#B0BAC4"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 192,
  r: 4,
  fill: "#292F35"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 192,
  r: 4,
  stroke: "#B0BAC4"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 239,
  r: 4,
  fill: "#292F35"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 135,
  cy: 239,
  r: 4,
  stroke: "#B0BAC4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M74 56C73.1716 56 72.5 56.6716 72.5 57.5V60.5H69.5C68.6716 60.5 68 61.1716 68 62C68 62.8284 68.6716 63.5 69.5 63.5H72.5V66.5C72.5 67.3284 73.1716 68 74 68C74.8284 68 75.5 67.3284 75.5 66.5V63.5H78.5C79.3284 63.5 80 62.8284 80 62C80 61.1716 79.3284 60.5 78.5 60.5H75.5V57.5C75.5 56.6716 74.8284 56 74 56Z",
  fill: "#848D96"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42 124C41.1716 124 40.5 124.672 40.5 125.5V128.5H37.5C36.6716 128.5 36 129.172 36 130C36 130.828 36.6716 131.5 37.5 131.5H40.5V134.5C40.5 135.328 41.1716 136 42 136C42.8284 136 43.5 135.328 43.5 134.5V131.5H46.5C47.3284 131.5 48 130.828 48 130C48 129.172 47.3284 128.5 46.5 128.5H43.5V125.5C43.5 124.672 42.8284 124 42 124Z",
  fill: "#4F555C"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159 238C158.172 238 157.5 238.672 157.5 239.5V242.5H154.5C153.672 242.5 153 243.172 153 244C153 244.828 153.672 245.5 154.5 245.5H157.5V248.5C157.5 249.328 158.172 250 159 250C159.828 250 160.5 249.328 160.5 248.5V245.5H163.5C164.328 245.5 165 244.828 165 244C165 243.172 164.328 242.5 163.5 242.5H160.5V239.5C160.5 238.672 159.828 238 159 238Z",
  fill: "#848D96"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M188.517 30H171.275V40.3448C171.275 44.1534 168.187 47.2414 164.379 47.2414H122.999C119.191 47.2414 116.103 44.1534 116.103 40.3448V30H98.8615C91.2443 30 85.0684 36.1759 85.0684 43.7931V216.207C85.0684 223.824 91.2443 230 98.8615 230H188.517C196.134 230 202.31 223.824 202.31 216.207V43.7931C202.31 36.1759 196.134 30 188.517 30Z",
  fill: "#848D96"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M85.0684 123.104V216.207C85.0684 223.824 91.2443 230 98.8615 230H185.068C129.797 230 85.0684 182.189 85.0684 123.104Z",
  fill: "#4F555C"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M122.999 47.2414H164.378C168.187 47.2414 171.275 44.1534 171.275 40.3448V30H116.103V40.3448C116.103 44.1534 119.19 47.2414 122.999 47.2414Z",
  fill: "#4F555C"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M100.999 70C100.999 68.3431 102.342 67 103.999 67H184.999C186.656 67 187.999 68.3431 187.999 70V124C187.999 125.657 186.656 127 184.999 127H103.999C102.342 127 100.999 125.657 100.999 124V70Z",
  fill: "#4F555C"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M100.999 137C100.999 135.343 102.342 134 103.999 134H184.999C186.656 134 187.999 135.343 187.999 137V189C187.999 190.657 186.656 192 184.999 192H103.999C102.342 192 100.999 190.657 100.999 189V137Z",
  fill: "#4F555C"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M247.138 61.0352H157.483C149.865 61.0352 143.689 67.2111 143.689 74.8283V130.001C143.689 137.618 149.865 143.794 157.483 143.794H171.276V159.705C171.276 161.48 173.415 162.375 174.679 161.13L192.275 143.794H247.138C254.755 143.794 260.931 137.618 260.931 130.001V74.8283C260.931 67.2111 254.755 61.0352 247.138 61.0352Z",
  fill: "#B0BAC4"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M112.654 216.207C112.654 214.303 114.198 212.759 116.103 212.759H171.275C173.179 212.759 174.723 214.303 174.723 216.207C174.723 218.112 173.179 219.655 171.275 219.655H116.103C114.198 219.655 112.654 218.112 112.654 216.207Z",
  fill: "#4F555C"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M160.931 81.7246C160.931 79.8202 162.475 78.2764 164.379 78.2764H171.276C173.18 78.2764 174.724 79.8202 174.724 81.7246C174.724 83.6291 173.18 85.1729 171.276 85.1729H164.379C162.475 85.1729 160.931 83.6291 160.931 81.7246Z",
  fill: "#292F35"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M185.068 81.7246C185.068 79.8202 186.612 78.2764 188.517 78.2764H240.241C242.145 78.2764 243.689 79.8202 243.689 81.7246C243.689 83.6291 242.145 85.1729 240.241 85.1729H188.517C186.612 85.1729 185.068 83.6291 185.068 81.7246Z",
  fill: "#292F35"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M160.931 102.414C160.931 100.51 162.475 98.9658 164.379 98.9658H171.276C173.18 98.9658 174.724 100.51 174.724 102.414C174.724 104.319 173.18 105.862 171.276 105.862H164.379C162.475 105.862 160.931 104.319 160.931 102.414Z",
  fill: "#292F35"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M185.068 102.414C185.068 100.51 186.612 98.9658 188.517 98.9658H240.241C242.145 98.9658 243.689 100.51 243.689 102.414C243.689 104.319 242.145 105.862 240.241 105.862H188.517C186.612 105.862 185.068 104.319 185.068 102.414Z",
  fill: "#292F35"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M160.931 123.104C160.931 121.199 162.475 119.655 164.379 119.655H171.276C173.18 119.655 174.724 121.199 174.724 123.104C174.724 125.008 173.18 126.552 171.276 126.552H164.379C162.475 126.552 160.931 125.008 160.931 123.104Z",
  fill: "#292F35"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M185.068 123.104C185.068 121.199 186.612 119.655 188.517 119.655H240.241C242.145 119.655 243.689 121.199 243.689 123.104C243.689 125.008 242.145 126.552 240.241 126.552H188.517C186.612 126.552 185.068 125.008 185.068 123.104Z",
  fill: "#292F35"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 226.999,
  cy: 177,
  r: 6,
  stroke: "#4F555C",
  strokeWidth: 4
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M157.972 162.115H156.359C156.04 160.745 155.502 159.46 154.779 158.3L155.92 157.159C156.321 156.758 156.321 156.107 155.92 155.706L153.293 153.08C152.892 152.679 152.241 152.679 151.84 153.08L150.699 154.221C149.54 153.498 148.255 152.96 146.885 152.641V151.028C146.885 150.46 146.425 150 145.857 150H142.142C141.575 150 141.115 150.46 141.115 151.028V152.641C139.745 152.96 138.46 153.498 137.3 154.221L136.16 153.08C135.759 152.679 135.108 152.679 134.707 153.08L132.08 155.707C131.679 156.108 131.679 156.759 132.08 157.16L133.221 158.301C132.498 159.46 131.96 160.745 131.641 162.115H130.028C129.46 162.115 129 162.575 129 163.143V166.858C129 167.425 129.46 167.885 130.028 167.885H131.641C131.96 169.255 132.498 170.54 133.221 171.7L132.08 172.84C131.679 173.242 131.679 173.892 132.08 174.293L134.707 176.92C135.108 177.321 135.759 177.321 136.16 176.92L137.301 175.779C138.461 176.501 139.746 177.04 141.116 177.359V178.972C141.115 179.54 141.575 180 142.143 180H145.858C146.425 180 146.885 179.54 146.885 178.972V177.359C148.255 177.04 149.54 176.502 150.7 175.779L151.841 176.92C152.242 177.321 152.893 177.321 153.294 176.92L155.92 174.293C156.321 173.892 156.321 173.241 155.92 172.84L154.779 171.699C155.502 170.54 156.04 169.254 156.359 167.884H157.973C158.54 167.885 159 167.425 159 166.857V163.142C159 162.575 158.54 162.115 157.972 162.115ZM144 170.192C141.132 170.192 138.808 167.867 138.808 165C138.808 162.132 141.132 159.808 144 159.808C146.868 159.808 149.192 162.132 149.192 165C149.192 167.867 146.868 170.192 144 170.192Z",
  fill: "#848D96"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M144 157.5C139.858 157.5 136.5 160.858 136.5 165C136.5 169.142 139.858 172.5 144 172.5C148.142 172.5 151.5 169.142 151.5 165C151.5 160.858 148.142 157.5 144 157.5ZM144 170.192C141.132 170.192 138.808 167.867 138.808 165C138.808 162.132 141.132 159.808 144 159.808C146.868 159.808 149.192 162.132 149.192 165C149.192 167.867 146.868 170.192 144 170.192Z",
  fill: "#B0BAC4"
});

var SvgMobileBuildsDark = function SvgMobileBuildsDark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMobileBuildsDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "media/MobileBuildsDark.59cc3320.svg";
export { ForwardRef as ReactComponent };